export default __webpack_public_path__ + "static/PMG_EGTB_HOHH_PDS_BANCA_ENG-d9e34cbb1faf48db33e2c8c945ccb59a.pdf";